import React, { ChangeEvent, ReactElement, useEffect, useRef, useState } from 'react'
import Container from '../containerComp/Container'
import { CreateWarningPropsTypes } from './CreateWarningTypes'
import { earlyWarningTypes } from './FixedDataSet'
import { APICallGetWarningTypeRequest, APIWarningTypeResponseType } from '../../services/APIEarlyWarningService'
import { useLocation, useNavigate } from 'react-router-dom'
import { APITemplateResponse } from '../../services/APITemplateService'
import EWTemplate from './EWTemplate'
import { useUserData } from '../../context/UserDataContext'
import EW from '../ewWarning/EW'

export type UserData = {
    accessprivileges: string;
    address: string;
    country: string;
    department: string;
    email: string;
    firstname: string;
    lastname: string;
    mobilenumber: string;
    nic: string;
    organization: string;
    policies: string;
    role: string;
    themecolorbconex: string;
    thememodebconex: string;
    thememodeeaglei: string;
    username: string;
}

export type PoliceTypes = {
    simple: boolean, 
    advanced: boolean, 
    defaultSimple: boolean, 
    defaultAdvanced: boolean
}

const CreateWarning = (props: CreateWarningPropsTypes) => {

    const location = useLocation();
    const paramsData = new URLSearchParams(location.search);
    const data = JSON.parse(paramsData.get("data") || "{}") as APIWarningTypeResponseType;

    const { username, hasPolicy, loading } = useUserData()

    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const navigate = useNavigate();

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const [selectedType, setSelectedType] = useState<APIWarningTypeResponseType>()
    const [selectedPage, setSelectedPage] = useState<"SELECT" | "FORM">('SELECT')

    const [warningTypes, setWarningTypes] = useState<APIWarningTypeResponseType[]>([]);

    const userIdRef = useRef<string>();

    const [selectedTemplate, setSelectedTemplate] = useState<APITemplateResponse | null>(null)

    const [userPolices, setUserPolices] = useState<PoliceTypes>({ simple: false, advanced: false, defaultSimple: false, defaultAdvanced: false})

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const result = await APICallGetWarningTypeRequest(username);
                setWarningTypes(result); // set response to state if needed
            } catch (error) {
                console.error("Initialization error:", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchInitialData();
    }, [loading])

    const handleEWTypeClick = (ewType: APIWarningTypeResponseType) => {
        setSelectedType(ewType)
        setSelectedPage("FORM")

    }

    const findIcon = (wType: string): ReactElement<any, any> | null => {
        const match = earlyWarningTypes.find(item => item.wType === wType);
        return match?.icon ?? null;
    }

    const [pendingCount, setPendingCount] = useState<number>(0)
    const [incidentCount, setIncidentCount] = useState<number>(0)

    const getPendingWarningCount = async () => {
        const token = localStorage.getItem("access_token");
        fetch(`${BASE_URL}/ew/api/v1/getPendingCount`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            const response = data as number
            //console.log(">>>>>>> data: ", data)
            setPendingCount(response)
        })
        .catch((err) => console.error("Error fetching roles:", err));
    }

    useEffect(() => {
        const params = new URLSearchParams()
        params.append("arealist", "LK1333")
        params.append("arealist", "LK1312")

        fetch (`${BASE_URL}/hz/api/v1/getHzmByLocationTwoWeek?${params.toString()}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            const response = data as []
            //console.log("incident data: ", response)
            setIncidentCount(response.length)
        })
        .catch(error => console.log(error))

        getPendingWarningCount()
    }, [])

    const [toggle, setToggle] = useState<boolean>(false)
    useEffect(() => {
        if (userPolices)
        {
            if (hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && !hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER")) 
            {
                setToggle(false)
            }
            else if (!hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER"))
            {
                setToggle(true)
            }

            if (hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && !hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(true)
            }
            else if (!hasPolicy("BOTH_EARLY_WARNING_TRIGGER_ADVANCED") && hasPolicy("BOTH_EARLY_WARNING_TRIGGER_SIMPLE"))
            {
                setToggle(false)
            }
        }
    }, [hasPolicy])

    useEffect(() => {
        const isEmpty = Object.keys(data).length === 0;
        if (isEmpty) {
        } else {
            setSelectedType(data)
            setSelectedPage("FORM")
        }
        
    }, [])

    return (
        <Container isLoading={isLoading}>
            <div className='create-warning'>
                <div className='title'>
                    <span>Generate Early Warnings</span>
                </div>
                {/* Type selector */}
                {selectedPage === 'SELECT' && (
                    <>
                        <div className='type-selector-wrapper'>
                            <div className='title'>
                                <span>Generate Early Warning</span>
                            </div>
                            {!selectedTemplate && (
                                (hasPolicy("SIMPLE_EARLY_WARNING_TRIGGER") && hasPolicy("ADVANCED_EARLY_WARNING_TRIGGER")) && (
                                    <div className="tab-wrapper">
                                        <div className="tab-button" style={{borderRadius: '0 0.5rem 0 0', backgroundColor: !toggle ? "var(--color-email-side-menu-bg)" : "transparent", borderWidth: toggle ? "0 0 0.2rem 0" : "0.2rem"}} onClick={(e) => setToggle(false)}>
                                            <span>Template-Based</span>
                                        </div>
                                        <div className="tab-button" style={{borderRadius: '0.5rem 0 0 0', borderWidth: !toggle ? "0 0 0.2rem 0" : "0.2rem", backgroundColor: toggle ? "var(--color-email-side-menu-bg)" : "transparent",}} onClick={(e) => setToggle(true)}>
                                            <span>Customized</span>
                                        </div>
                                    </div>
                                )
                            )}
                            
                            {toggle && (
                                <>
                                    {warningTypes.length > 0 ? (
                                        <div className='type-selector-wrapper-container'>
                                            {warningTypes.map((ewType, index) => (
                                                <div key={index} className='ew-item' onClick={(e) => handleEWTypeClick(ewType)} style={{backgroundColor: selectedType?.warningId === ewType.warningId ? 'var(--color-card-select-bg)' : 'var(--color-card-bg)'}}>
                                                    {findIcon(ewType.hazardType)}
                                                    <span>{ewType.warningName}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='type-selector-wrapper-container-empty'>
                                            <span>No any warning types available for you</span>
                                        </div>
                                    )}
                                </>
                                
                            )}
                            {!toggle && (
                                hasPolicy('SIMPLE_EARLY_WARNING_TRIGGER') && (
                                    <EWTemplate selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} setToggle={setToggle} isButtonActive={warningTypes.length > 0 ? true : false}/>
                                )
                            )}
                            
                        </div>
                    </>
                )}
               
                {selectedPage === "FORM" && (
                    <div>
                        {selectedType && (
                            <EW flowId={selectedType.warningId} flowName={selectedType.warningName} department={selectedType.departments} hazardType={selectedType.hazardType} warningName={selectedType.warningName} warningType={selectedType.warningType} />
                        )}
                        
                    </div>
                )}
            </div>
        </Container>
    )
}

export default CreateWarning